// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2DD01","right":"Footer_right__m61-A","buttons":"Footer_buttons__rFFXd"};